import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import {
  Button, DialogActions, DialogContent
} from '@material-ui/core';
import { translate } from 'utils';
import { ModalHeader } from './_ModalHeader';

export const ErrorModal = ({
  onClose, afterClose, text, title
}) => {
  const handleClose = useCallback(() => {
    onClose();
    afterClose && afterClose();
  }, [onClose, afterClose]);

  return (
    <>
      <ModalHeader className="errorModal">
        <FontAwesomeIcon icon={faTimes} />
        {translate(title)}
      </ModalHeader>

      <DialogContent dangerouslySetInnerHTML={{ __html: text }} />

      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          {translate('button.close')}
        </Button>
      </DialogActions>
    </>
  );
};

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  afterClose: PropTypes.func,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({})
  ]),
  title: PropTypes.string
};

ErrorModal.defaultProps = {
  afterClose: () => {},
  text: '',
  title: 'errors.default'
};